module.exports = __webpack_public_path__ + "static/media/story-thumbnail-placeholder.78b87f9b.jpg";